import { useState, useEffect } from 'react'
import Home from './pages/Home'
import Template from './pages/NavAppTemplate'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { ISection } from './@customTypes/generated/contentful'
import styles from './App.module.css'

declare global {
  interface Window {
    snapStore?: any
  }
}

interface ComponentProps {
  navAppIndex: number
}

function App({ navAppIndex }: ComponentProps) {
  const [sections, setSections] = useState<ISection[] | null>(null)
  const slugsEndpoint = `${process.env.PUBLIC_URL}/data/slugs.json`
  useEffect(() => {
    const getSlugs = async () => {
      console.log('FETCH!')
      const response = await fetch(slugsEndpoint)
      const items = await response.json()
      setSections(items)
    }
    if (window.snapStore) {
      setSections(window.snapStore[slugsEndpoint])
    } else {
      getSlugs()
    }
  }, [slugsEndpoint])

  const sectionIdFromStaticPageEl = global.document.querySelectorAll(
    '[data-section-id]'
  )[navAppIndex] as HTMLElement
  let sectionIdFromStaticPage
  if (sectionIdFromStaticPageEl) {
    sectionIdFromStaticPage = sectionIdFromStaticPageEl.dataset.sectionId
  }

  return (
    <div className={styles.app}>
      <Router>
        <Routes>
          {sectionIdFromStaticPage ? (
            <Route
              path='*'
              element={
                <Template
                  sectionId={sectionIdFromStaticPage}
                  navAppIndex={navAppIndex}
                />
              }
            />
          ) : (
            <>
              <Route
                path={`${process.env.PUBLIC_URL}`}
                element={<Home sections={sections} />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/index.html`}
                element={<Home sections={sections} />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/sections/index.html`}
                element={<Home sections={sections} />}
              />
              {sections &&
                sections.map((section, index) => (
                  <Route
                    key={`route-${index}-${navAppIndex}`}
                    path={`${process.env.PUBLIC_URL}/${section.fields.slug}/index.html`}
                    element={
                      <Template
                        key={`template-${index}-${navAppIndex}`}
                        sectionId={section.sys.id}
                        navAppIndex={navAppIndex}
                      />
                    }
                  />
                ))}
            </>
          )}
        </Routes>
      </Router>
    </div>
  )
}

export default App
